import React from 'react'


const GlobalsContext = React.createContext<{ globals: Globals }>(null)


export default GlobalsContext
